import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { colors } from "@/theme/colors";

type Props = {
  size?: number;
};

// 遅延ルート読み込み中のフォールバック UI。AppLayout / CourseDetailLayout で共有する。
export function RouteFallback({ size = 32 }: Props) {
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: 200,
      }}
    >
      <CircularProgress size={size} sx={{ color: colors.gold }} />
    </Box>
  );
}
